import store from "../../../../redux/store";

import {
  Heading,
  Box,
  SimpleGrid,
  Text,
  HStack,
  VStack,
  Icon,
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "@chakra-ui/react";
import { Tabs, TabList, Tab } from "@chakra-ui/react";

import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";

import { downloadExcel } from "react-export-table-to-excel";
import "../analytics.css";

import { RadialChart } from "react-vis";
import { FiPhoneOff } from "react-icons/fi";
import {
  MdCall,
  MdCheckCircle,
  MdError,
  MdLoop,
  MdPhoneForwarded,
  MdInfoOutline,
  MdDownload,
} from "react-icons/md";

import ZetScenarioId32Table from "views/admin/niclAnalytics/components/ZetScenarioId32Table";
import UnAnswereAnalyticsTable from "views/admin/niclAnalytics/components/UnAnswereAnalyticsTable";

import { UnansweredCallTableColumns } from "views/admin/niclAnalytics/variables/columnsData";

import { React, useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import {
  getAnalyticsDataAction,
  getAnalyticsCallBreakDownDataAction,
  getAnalyticsUnansweredDataAction,
} from "../../../../redux/actions/analytics";

import { convertDateToLocal, convertCallDurationToMin ,convertCallDurationToMinExcel} from "utils/Utils";
import { DownloadIcon } from "@chakra-ui/icons";
import { flow32BhartiAXA } from "../variables/columnsData";
import { exportDashboardApiData } from "../../../../redux/agent";

export default function ZetScenario32Dashboard(props) {
  const dispatch = useDispatch();
  const [analyticsTablePageNo, setAnalyticsTablePageNo] = useState(1);
  const [pageLimitanalyticsTable, setLimitAnalyticsTable] = useState(10);
  const [analyticsFilter, setAnalyticsFilter] = useState({
    isfilter: false,
    phoneNumber: "",
    sessionId: "",
    customerName: "",
    productName: "",
    language: "",
    agentName: "",
    sendSms: "",
    customerQueries: "",
    l1SubQueries: "",
    l2SubQueries: "",
    l3SubQueries: "",
  });

  const [callDurationFilter, setCallDurationFilter] = useState("default"); // default, gt-1-min-and-lt-2-mins, lt-1-min
  const [unansweredTablePageNo, setUnansweredsTablePageNo] = useState(1);
  const [pageLimitUnansweredTable, setLimitUnansweredTable] = useState(10);
  const [unansweredFilter, setUnansweredFilter] = useState({
    isfilter: false,
    phoneNumber: "",
    sessionId: "",
  });
  const [callInfoCounts, setCallInfoCounts] = useState({});
  const [refreshKey, setRefreshKey] = useState(0);

  const userData = useSelector((state) => state.userData);

  const callBreakDownData = useSelector(
    (state) => state.analyticsData.callBreakDownData.callAnalytics
  );
  const analyticsData = useSelector(
    (state) => state.analyticsData.analyticsTableProperties
  );

  console.log("callBreakDownData--", callBreakDownData);

  const unansweredUserData = useSelector(
    (state) => state.analyticsData.analyticsTableUnansweredProperties
  );
  console.log("Filter data", analyticsFilter);
  useEffect(() => {
    if (props.selectedDateRange.startDate && props.selectedDateRange.endDate) {
      dispatch(
        getAnalyticsDataAction({
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: props.workFlowData?.id,
          limit: pageLimitanalyticsTable,
          page: analyticsTablePageNo,
          token: userData.token,
          ...analyticsFilter,
        })
      );
      dispatch(
        getAnalyticsCallBreakDownDataAction({
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: props.workFlowData?.id,
          token: userData.token,
        })
      );
      dispatch(
        getAnalyticsUnansweredDataAction({
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: props.workFlowData?.id,
          limit: pageLimitUnansweredTable,
          page: unansweredTablePageNo,
          token: userData.token,
        })
      );
    }
    // invokedGetAnalyticsApiDataCall()
  }, [props.selectedDateRange, props.workFlowData]);

  useEffect(() => {
    if (props.selectedDateRange.startDate && props.selectedDateRange.endDate) {
      // console.log("selectedDateRange if");
      dispatch(
        getAnalyticsDataAction({
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: props.workFlowData?.id,
          limit: pageLimitanalyticsTable,
          page: analyticsTablePageNo,
          token: userData.token,
          callDuration: callDurationFilter,
          ...analyticsFilter,
        })
      );
    }
  }, [
    analyticsTablePageNo,
    pageLimitanalyticsTable,
    callDurationFilter,
    refreshKey,
  ]);

  useEffect(() => {
    if (props.selectedDateRange.startDate && props.selectedDateRange.endDate) {
      // console.log("selectedDateRange if");
      dispatch(
        getAnalyticsUnansweredDataAction({
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: props.workFlowData?.id,
          limit: pageLimitUnansweredTable,
          page: unansweredTablePageNo,
          token: userData.token,
        })
      );
    }
    // invokedGetAnalyticsApiDataCall()
  }, [unansweredTablePageNo, pageLimitUnansweredTable]);

  const applyFilterAnalytisData = () => {
    setAnalyticsFilter({
      ...analyticsFilter,
      isfilter: true,
    });
    dispatch(
      getAnalyticsDataAction({
        selectedDateRange: props.selectedDateRange,
        clientName: "NICL",
        scenarioID: props.workFlowData?.id,
        limit: pageLimitanalyticsTable,
        page: analyticsTablePageNo,
        token: userData.token,
        ...analyticsFilter,
        isfilter: true,
      })
    );
  };

  const TAB_KEYS = [
    "default",
    "lt-1-min",
    "gt-1-min-and-lt-2-mins",
    "gt-2-min-and-lt-3-mins",
    "gt-3-min-and-lt-4-mins",
    "gt-4-min-and-lt-5-mins",
    "gt-5-mins",
    "bot-callback",
    "issue-resolved",
    "not-completed",
  ];

  const CALL_DURATIONS = [
    {
      key: "lt-1-min",
      label: "Call Duration Less than 1 min",
    },
    {
      key: "gt-1-min-and-lt-2-mins",
      label: "Call Duration Between 1 and 2 min",
    },
    {
      key: "gt-2-min-and-lt-3-mins",
      label: "Call Duration Between 2 and 3 min",
    },
    {
      key: "gt-3-min-and-lt-4-mins",
      label: "Call Duration Between 3 and 4 min",
    },
  ];

  useEffect(() => {
    if (!props.modalAllcallBreakdownData) return;

    const fetchAllDurationCounts = async () => {
      const counts = {};

      for (const row of CALL_DURATIONS) {
        await dispatch(
          getAnalyticsDataAction({
            selectedDateRange: props.selectedDateRange,
            clientName: "NICL",
            scenarioID: props.workFlowData?.id,
            limit: 1, // IMPORTANT: fast call
            page: 1,
            token: userData.token,
            callDuration: row.key,
          })
        );

        const updatedAnalytics =
          store.getState().analyticsData.analyticsTableProperties;

        counts[row.key] = updatedAnalytics?.totalCount || 0;
      }

      setCallInfoCounts(counts);
    };

    fetchAllDurationCounts();
  }, [props.modalAllcallBreakdownData]);

  const discardFilterAnalytisData = () => {
    dispatch(
      getAnalyticsDataAction({
        selectedDateRange: props.selectedDateRange,
        clientName: "NICL",
        scenarioID: props.workFlowData?.id,
        limit: pageLimitanalyticsTable,
        page: analyticsTablePageNo,
        token: userData.token,
      })
    );
    setAnalyticsFilter({
      isfilter: false,
      phoneNumber: "",
      sessionId: "",
      customerName: "",
      productName: "",
      language: "",
      agentName: "",
      sendSms: "",
      customerQueries: "",
      l1SubQueries: "",
      l2SubQueries: "",
      l3SubQueries: "",
    });
  };

  const applyFilteUnansweredData = () => {
    dispatch(
      getAnalyticsUnansweredDataAction({
        selectedDateRange: props.selectedDateRange,
        clientName: "NICL",
        scenarioID: props.workFlowData?.id,
        limit: pageLimitUnansweredTable,
        page: unansweredTablePageNo,
        token: userData.token,
        ...unansweredFilter,
      })
    );
  };

  const discardFilterUnansweredData = () => {
    dispatch(
      getAnalyticsUnansweredDataAction({
        selectedDateRange: props.selectedDateRange,
        clientName: "NICL",
        scenarioID: props.workFlowData?.id,
        limit: pageLimitUnansweredTable,
        page: unansweredTablePageNo,
        token: userData.token,
      })
    );
    setUnansweredFilter({ isfilter: false, phoneNumber: "", sessionId: "" });
  };

  const convertToString = (data) => {
    if (data !== null && data !== undefined) {
      return data.toString();
    } else {
      return "";
    }
  };

  const getDisposition = (data) => {
    let disposotionstring = "";
    if (data && data.length) {
      disposotionstring = data[data.length - 1];
      return disposotionstring;
    } else {
      return disposotionstring;
    }
  };
  const checkCallBackType = (data) => {
    if (data && data?.callback_requested === true) {
      if (data && data.call_back_requested_by === "user") {
        return "User Request";
      } else {
        return "Bot callback";
      }
    } else {
      return "";
    }
  };
  const checkCallInfo = (data) => {
    if (data && data?.issue_resolved === true) {
      return "Issue Resolved";
    } else if (data && data?.callback_requested === true) {
      if (data && data?.call_back_requested_by === "agent") {
        return "Callback By Agent";
      } else {
        return "Callback By User";
      }
    } else if (data && data?.call_not_completed === true) {
      return "Call Not Completed";
    } else {
      return "Not Resolved";
    }
  };

  const getAudioEndpoint = (data, woSAS = true) => {
    const url = data?.callRecording;
    const timestamp = data?.response_time_utc || data?.response_time;

    const date = new Date(timestamp);

    // Format YYYY/MM/DD/
    const formatted =
      "/" +
      date.getFullYear() +
      "/" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "/" +
      String(date.getDate()).padStart(2, "0") +
      "/";

    console.log("formatted date", formatted);
    if (url) {
      // setAudioUrl(cell.value);
      const parts = url.split("/");
      let fileName = "";
      if (parts.length > 0) {
        console.log("File Name", parts[parts.length - 1]);
        fileName = parts[parts.length - 1];
      }

      let modifiedUrl = `https://teckinfostoragejiowest.blob.core.windows.net/teckinfo-call-recordings${formatted}${fileName}`;

      // const audioUrlFromBlob = downloadAudioFileFromBlob(modifiedUrl);
      // console.log("Aduio url ---->", audioUrlFromBlob);

      return modifiedUrl;
    }
  };

  const exportDashboardData = async (exportType) => {
    let payloadExportData = {
      queryType: exportType,
      scenarioID: props.workFlowData?.id,
      selectedDateRange: props.selectedDateRange,
      token: userData.token,
    };

    const exportDataResponse = await exportDashboardApiData(payloadExportData);
    console.log("Export data", exportDataResponse);

    let exportData = exportDataResponse?.data;
    const headersArray = flow32BhartiAXA.map((column) => {
      return column.Header;
    });

    // headersArray.splice(headersArray?.length - 2, 0, "Transcription");

    const generateTranscription = (transcript) => {
      let transcriptMessage = "";
      if (transcript && transcript.length) {
        for (let i = 0; i < transcript.length; i++) {
          if (transcript[i].bot) {
            transcriptMessage =
              transcriptMessage +
              "Bot : " +
              transcript[i]?.message[0] +
              " || \n";
          } else {
            transcriptMessage =
              transcriptMessage +
              "Customer : " +
              transcript[i]?.message[0] +
              " || \n";
          }
        }
        return transcriptMessage;
      }
    };

    let modifiedDataArray = exportData.map((dataObject) => {
      let myDate = convertDateToLocal(dataObject.response_time);

      let callDuration = convertCallDurationToMinExcel(dataObject.callDuration);
      let callAnanlytics = dataObject?.callAnanlytics;

      let modifiedData = {
        phoneNumber: dataObject?.userId,
        sessionId: dataObject?.sessionId,
        callInfo: checkCallInfo(callAnanlytics),
        issueResolved: convertToString(callAnanlytics?.issue_resolved),
        call_transfer: convertToString(callAnanlytics?.callback_requested),
        callNotComplete: convertToString(callAnanlytics?.call_not_completed),
        callAbandoned: convertToString(dataObject?.call_abandoned),
        csatRating:convertToString(callAnanlytics?.feedback_rating),
        callDuration: convertToString(callDuration),
        callRecording: getAudioEndpoint(dataObject, true),
        customerQueries: convertToString(
          callAnanlytics?.list_of_customer_queries
        ),
        l1SubQuery: convertToString(callAnanlytics?.L1_sub_query),
        l2SubQuery: convertToString(callAnanlytics?.L2_sub_query),
        l3SubQuery: convertToString(callAnanlytics?.L3_sub_query),
        // issue_resolved: convertToString(callAnanlytics?.issue_resolved),
        callBackArrangedBy: convertToString(
          callAnanlytics?.call_back_requested_by
        ),
        callBackType: checkCallBackType(callAnanlytics),

        // conversationCompleted: convertToString(
        //   callAnanlytics?.conversationCompleted
        // ),

        callType: convertToString(callAnanlytics?.call_type),

        // transcription: generateTranscription(dataObject?.transcript),
        language: convertToString(callAnanlytics?.language),

        response_time: myDate,
      };

      return modifiedData;
    });

    console.log("modified data array", modifiedDataArray);

    if (modifiedDataArray?.length) {
      downloadExcel({
        fileName: exportType,
        sheet: "Sheet 1",
        tablePayload: {
          header: headersArray,
          body: modifiedDataArray,
        },
      });
    }
  };

  const getSegrigationTabTitles = (key) => {
    if (key === "default") {
      return {
        title: "All Calls",
        count: callBreakDownData?.totalCallAttempt || 0,
      };
    } else if (key === "lt-1-min") {
      return {
        title: "Calls less than 1 min",
        count: callBreakDownData?.callDataLessThan1Mins || 0,
      };
    } else if (key === "gt-1-min-and-lt-2-mins") {
      return {
        title: "Calls 1–2 min",
        count: callBreakDownData?.callDataBetn1minsTo2Mins || 0,
      };
    } else if (key === "gt-2-min-and-lt-3-mins") {
      return {
        title: "Calls 2–3 min",
        count: callBreakDownData?.callDataBetn2minsTo3Mins || 0,
      };
    } else if (key === "gt-3-min-and-lt-4-mins") {
      return {
        title: "Calls 3-4 min",
        count: callBreakDownData?.callDataBetn3minsTo4Mins || 0,
      };
    } else if (key === "gt-4-min-and-lt-5-mins") {
      return {
        title: "Calls 4-5 min",
        count: callBreakDownData?.callDataBetn4minsTo5Mins || 0,
      };
    } else if (key === "gt-5-mins") {
      return {
        title: "Calls more than 5 min",
        count: callBreakDownData?.callDataMoreThan5Mins || 0,
      };
    } else if (key === "issue-not-resolved") {
      return {
        title: "Call-back request/issue not resolved",
        count: callBreakDownData?.callDataIssueNotResolved || 0,
      };
    } else if (key === "issue-resolved") {
      return {
        title: "Issue resolved",
        count: callBreakDownData?.callDataIssueResolved || 0,
      };
    } else if (key === "bot-callback") {
      return {
        title: "Callback requested",
        count: callBreakDownData?.callDatacallbackRequested || 0,
      };
    } else if (key === "not-completed") {
      return {
        title: "Call not completed",
        count: callBreakDownData?.callDataqueryCallDisconnected || 0,
      };
    }
  };

  return (
    <>
      <HStack
        spacing="24px"
        align="stretch"
        className="sbscoAnalyticsDBContainer"
      >
        <Box
          className="dbBlock"
          w="40%"
          minH="340px"
          bg="white"
          overflowY="auto"
        >
          <Heading as="h6" size="xs" m="12px">
            {props.workFlowData?.name}
          </Heading>
          <HStack spacing={6} align="start" mt={4}>
            <div className="radialChart">
              <RadialChart
                data={[
                  {
                    angle:
                      (callBreakDownData?.callDataIssueResolved /
                        callBreakDownData?.totalCallAttempt) *
                      360,
                    innerRadius: 0.88,
                    color: "#34eb89", // Green - Issue Resolved
                  },
                  {
                    angle:
                      (callBreakDownData?.callDataCallBackRequestedByAgent /
                        callBreakDownData?.totalCallAttempt) *
                      360,
                    innerRadius: 0.88,
                    color: "#3182CE", // Blue - Bot Callback
                  },
                  {
                    angle:
                      (callBreakDownData?.callDataCallBackArrangedByCustomer /
                        callBreakDownData?.totalCallAttempt) *
                      360,
                    innerRadius: 0.88,
                    color: "#805AD5", // Purple - Customer requested
                  },
                  {
                    angle:
                      (callBreakDownData?.callDataqueryCallDisconnected /
                        callBreakDownData?.totalCallAttempt) *
                      360,
                    innerRadius: 0.88,
                    color: "#D6BCFA", // Light Purple - Disconnected
                  },
                  // {
                  //   angle:
                  //     ((callBreakDownData?.callDataIssueNotResolved -
                  //       (callBreakDownData?.callDataCallbackArranged +
                  //         callBreakDownData?.notCompleted)) /
                  //       callBreakDownData?.totalCallAttempt) *
                  //     360,
                  //   innerRadius: 0.88,
                  //   color: "#A0AEC0", // Grey - Remaining/Other
                  // },
                ]}
                width={180}
                height={180}
                colorType="literal"
              />
              <div className="radialText">
                <Text fontSize="sm" color="gray.500" fontWeight="500">
                  Total calls
                </Text>
                <Heading size="lg" color="gray.700">
                  {callBreakDownData?.totalCallAttempt}
                </Heading>
              </div>
            </div>

            <VStack spacing={4} align="stretch" flex="1">
              <Box>
                <Text
                  fontSize="sm"
                  fontWeight="bold"
                  color="gray.700"
                  mb={2}
                  borderBottom="1px solid"
                  borderColor="gray.200"
                  pb={1}
                >
                  Call Breakdown
                </Text>
                <VStack spacing={3} align="stretch">
                  <Flex align="center" justify="space-between">
                    <HStack spacing={2} align="center">
                      <Box
                        h="10px"
                        minW="10px"
                        bg="#34eb89"
                        borderRadius="full"
                      />
                      <Text fontSize="sm" color="gray.700" fontWeight="500">
                        Issue resolved
                      </Text>
                    </HStack>
                    <Text fontSize="sm" fontWeight="700" color="gray.800">
                      {callBreakDownData?.callDataIssueResolved}
                    </Text>
                  </Flex>

                  <Flex align="center" justify="space-between">
                    <HStack spacing={2} align="center">
                      <Box
                        h="10px"
                        minW="10px"
                        bg="#3182CE"
                        borderRadius="full"
                      />
                      <Text fontSize="sm" color="gray.700" fontWeight="500">
                        Call back arranged by bot
                      </Text>
                    </HStack>
                    <Text fontSize="sm" fontWeight="700" color="gray.800">
                      {callBreakDownData?.callDataCallBackRequestedByAgent || 0}
                    </Text>
                  </Flex>

                  <Flex align="center" justify="space-between">
                    <HStack spacing={2} align="center">
                      <Box
                        h="10px"
                        minW="10px"
                        bg="#805AD5"
                        borderRadius="full"
                      />
                      <Text fontSize="sm" color="gray.700" fontWeight="500">
                        Customer requested callback
                      </Text>
                    </HStack>
                    <Text fontSize="sm" fontWeight="700" color="gray.800">
                      {callBreakDownData?.callDataCallBackArrangedByCustomer ||
                        0}
                    </Text>
                  </Flex>

                  <Flex align="center" justify="space-between">
                    <HStack spacing={2} align="center">
                      <Box
                        h="10px"
                        minW="10px"
                        bg="#D6BCFA"
                        borderRadius="full"
                      />
                      <Text fontSize="sm" color="gray.700" fontWeight="500">
                        Incomplete calls
                      </Text>
                    </HStack>
                    <Text fontSize="sm" fontWeight="700" color="gray.800">
                      {callBreakDownData?.callDataqueryCallDisconnected}
                    </Text>
                  </Flex>
                </VStack>
              </Box>

              <Box mt={2}>
                <Text
                  fontSize="sm"
                  fontWeight="bold"
                  color="gray.700"
                  mb={2}
                  borderBottom="1px solid"
                  borderColor="gray.200"
                  pb={1}
                >
                  Connectivity Stats
                </Text>
                <VStack spacing={2} align="stretch">
                  <Flex align="center" justify="space-between">
                    <HStack spacing={2} align="center">
                      <Box
                        h="10px"
                        minW="10px"
                        bg="red.400"
                        borderRadius="full"
                      />
                      <Text fontSize="sm" color="gray.600" fontWeight="500">
                        Unanswered
                      </Text>
                    </HStack>
                    <Text fontSize="sm" fontWeight="700" color="red.500">
                      {callBreakDownData?.totalUnanswered || 0}
                    </Text>
                  </Flex>

                  <Flex align="center" justify="space-between">
                    <HStack spacing={2} align="center">
                      <Box
                        h="10px"
                        minW="10px"
                        bg="gray.400"
                        borderRadius="full"
                      />
                      <Text fontSize="sm" color="gray.600" fontWeight="500">
                        No response
                      </Text>
                    </HStack>
                    <Text fontSize="sm" fontWeight="700" color="gray.600">
                      {callBreakDownData?.noResponseCount || 0}
                    </Text>
                  </Flex>
                </VStack>
              </Box>
            </VStack>
          </HStack>
        </Box>

        <HStack spacing={6} align="stretch" flex="1">
          {/* Right Side: Combined Box with All Metrics */}
          <Box
            bg="white"
            p={6}
            borderRadius="md"
            border="1px solid"
            borderColor="gray.300"
            flex="1"
          >
            <HStack spacing={6} align="stretch">
              {/* Left Section: Two Metric Cards Stacked */}
              <VStack spacing={4} flex="1">
                {/* Card 1: Total Successful Calls */}
                <Flex
                  bg="blue.50"
                  p={4}
                  borderRadius="md"
                  borderLeft="4px solid"
                  borderLeftColor="blue.500"
                  direction="column"
                  justify="space-between"
                  w="100%"
                  minH="140px"
                >
                  <Flex justify="space-between" align="center" mb={2}>
                    <Text fontSize="sm" fontWeight="600" color="blue.900">
                      Total calls handled
                    </Text>
                    <HStack
                      spacing={1}
                      cursor="pointer"
                      onClick={() => exportDashboardData("total-call")}
                      color="blue.700"
                      _hover={{ color: "blue.900" }}
                    >
                      <Text fontSize="xs" fontWeight="700">
                        Export
                      </Text>
                      <Icon
                        as={MdDownload}
                        w={4}
                        h={4}
                        title="Export Successful Calls"
                      />
                    </HStack>
                  </Flex>
                  <Heading size="xl" color="blue.700">
                    {callBreakDownData?.successfulCall || 0}
                  </Heading>
                </Flex>

                {/* Card 2: Issue Resolved */}
                <Flex
                  bg="green.50"
                  p={4}
                  borderRadius="md"
                  borderLeft="4px solid"
                  borderLeftColor="green.500"
                  direction="column"
                  justify="space-between"
                  w="100%"
                  minH="140px"
                >
                  <Flex justify="space-between" align="center" mb={2}>
                    <Text fontSize="sm" fontWeight="600" color="green.900">
                      Issue resolved
                    </Text>
                    <HStack
                      spacing={1}
                      cursor="pointer"
                      onClick={() => exportDashboardData("issue-resolved")}
                      color="green.700"
                      _hover={{ color: "green.900" }}
                    >
                      <Text fontSize="xs" fontWeight="700">
                        Export
                      </Text>
                      <Icon
                        as={MdDownload}
                        w={4}
                        h={4}
                        title="Export Issue Resolved"
                      />
                    </HStack>
                  </Flex>
                  <Heading size="xl" color="green.700">
                    {callBreakDownData?.callDataIssueResolved || 0}
                  </Heading>
                </Flex>
              </VStack>

              {/* Right Section: Hierarchical Breakdown */}
              <Box flex="1.5">
                {/* Header with total count */}
                <Flex align="center" justify="space-between" mb={4}>
                  <Flex align="baseline">
                    <Text
                      fontSize="md"
                      fontWeight="600"
                      color="gray.800"
                      mr={2}
                    >
                      Callback arranged
                    </Text>
                    <Heading size="lg" color="blue.600">
                      {callBreakDownData?.callDatacallbackRequested || 0}
                    </Heading>
                  </Flex>
                  <HStack
                    spacing={1}
                    cursor="pointer"
                    onClick={() =>
                      exportDashboardData(
                        "issue-not-resolved/callback-arranged"
                      )
                    }
                    color="blue.600"
                    _hover={{ color: "orange.800" }}
                  >
                    <Text fontSize="xs" fontWeight="700">
                      Export
                    </Text>
                    <Icon
                      as={MdDownload}
                      w={5}
                      h={5}
                      title="Export Issue Not Resolved"
                    />
                  </HStack>
                </Flex>

                <VStack spacing={3} align="stretch">
                  {/* Card 1: Bot Callback */}
                  <Flex
                    bg="blue.50"
                    p={4}
                    borderRadius="md"
                    borderLeft="4px solid"
                    borderLeftColor="blue.500"
                    align="center"
                    justify="space-between"
                  >
                    <HStack spacing={2}>
                      <Box
                        bg="blue.500"
                        color="white"
                        w="24px"
                        h="24px"
                        borderRadius="md"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        fontSize="xs"
                        fontWeight="bold"
                      >
                        1
                      </Box>
                      <Text fontSize="sm" fontWeight="600" color="blue.900">
                        Call back arranged by bot
                      </Text>
                    </HStack>
                    <Text fontSize="lg" fontWeight="800" color="blue.700">
                      {callBreakDownData?.callDataCallBackRequestedByAgent || 0}
                    </Text>
                  </Flex>

                  {/* Card 2: User Callback with sub-items */}
                  <Box
                    bg="purple.50"
                    p={4}
                    borderRadius="md"
                    borderLeft="4px solid"
                    borderLeftColor="purple.500"
                  >
                    <Flex align="center" justify="space-between" mb={3}>
                      <HStack spacing={2}>
                        <Box
                          bg="purple.500"
                          color="white"
                          w="24px"
                          h="24px"
                          borderRadius="md"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          fontSize="xs"
                          fontWeight="bold"
                        >
                          2
                        </Box>
                        <Text fontSize="sm" fontWeight="600" color="purple.900">
                          Call back arranged by User
                        </Text>
                      </HStack>
                      <Text fontSize="lg" fontWeight="800" color="purple.700">
                        {callBreakDownData?.callDataCallBackArrangedByCustomer ||
                          0}
                      </Text>
                    </Flex>

                    {/* Sub-items */}
                    <VStack spacing={2} align="stretch" pl={8}>
                      {/* <Flex
                        bg="white"
                        p={2.5}
                        borderRadius="sm"
                        align="center"
                        justify="space-between"
                      >
                        <HStack spacing={2}>
                          <Box
                            bg="purple.200"
                            color="purple.800"
                            w="20px"
                            h="20px"
                            borderRadius="sm"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            fontSize="xs"
                            fontWeight="bold"
                          >
                            a
                          </Box>
                          <Text fontSize="xs" color="gray.700">
                            Customer requested callback
                          </Text>
                        </HStack>
                        <Text fontSize="sm" fontWeight="700" color="purple.600">
                          {Math.floor(
                            callBreakDownData?.callDataqueryCallBackRequestedByUserHimself ||
                              0
                          )}
                        </Text>
                      </Flex> */}

                      {/* <Flex
                        bg="white"
                        p={2.5}
                        borderRadius="sm"
                        align="center"
                        justify="space-between"
                      >
                        <HStack spacing={2}>
                          <Box
                            bg="purple.200"
                            color="purple.800"
                            w="20px"
                            h="20px"
                            borderRadius="sm"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            fontSize="xs"
                            fontWeight="bold"
                          >
                            b
                          </Box>
                          <Text fontSize="xs" color="gray.700">
                            Call disconnected/incomplete
                          </Text>
                        </HStack>
                        <Text fontSize="sm" fontWeight="700" color="purple.600">
                          {Math.floor(
                            callBreakDownData?.callDataCallBackRequestedForDisconnectedCustomer ||
                              0
                          )}
                        </Text>
                      </Flex> */}
                    </VStack>
                  </Box>
                </VStack>

                <Flex
                  mt={6}
                  bg="red.50"
                  p={4}
                  borderRadius="md"
                  borderLeft="4px solid"
                  borderLeftColor="red.500"
                >
                  <Flex align="center" justify="space-between" w="100%">
                    <Flex align="baseline">
                      <Text
                        fontSize="md"
                        fontWeight="600"
                        color="red.900"
                        mr={2}
                      >
                        Incomplete calls
                      </Text>
                      <Heading size="lg" color="red.700">
                        {callBreakDownData?.callDataqueryCallDisconnected || 0}
                      </Heading>
                    </Flex>
                    <HStack
                      spacing={1}
                      cursor="pointer"
                      onClick={() =>
                        exportDashboardData("not-completed/incomplete-calls")
                      }
                      color="red.700"
                      _hover={{ color: "red.900" }}
                    >
                      <Text fontSize="xs" fontWeight="700">
                        Export
                      </Text>
                      <Icon
                        as={MdDownload}
                        w={5}
                        h={5}
                        title="Export Incomplete Calls"
                      />
                    </HStack>
                  </Flex>
                </Flex>
              </Box>
            </HStack>
          </Box>
        </HStack>
      </HStack>
      <br></br>
      <Tabs
        index={TAB_KEYS.indexOf(callDurationFilter)}
        variant="solid-rounded"
        colorScheme="blue"
        onChange={(index) => setCallDurationFilter(TAB_KEYS[index])}
      >
        <TabList gap={2} p={2} bg="gray.100" borderRadius="md">
          {TAB_KEYS.map((key) => (
            <Tab
              key={key}
              fontSize="xs"
              px={1}
              py={2}
              borderRadius="md"
              _selected={{ bg: "blue.500", color: "white" }}
              _hover={{ bg: "blue.200" }}
            >
              {getSegrigationTabTitles(key)?.title} (
              {getSegrigationTabTitles(key)?.count})
            </Tab>
          ))}
        </TabList>
      </Tabs>

      <Box className="sbscoTable">
        <SimpleGrid
          mb="20px"
          columns="1"
          spacing={{ base: "20px", xl: "20px" }}
        >
          <div className="sbscoTableContainer mcaTable">
            <ZetScenarioId32Table
              title={props.workFlowData?.name}
              columnsData={flow32BhartiAXA}
              tableData={analyticsData}
              isEvening={false}
              setAnalyticsTablePageNo={setAnalyticsTablePageNo}
              analyticsTablePageNo={analyticsTablePageNo}
              pageLimitanalyticsTable={pageLimitanalyticsTable}
              setLimitAnalyticsTable={setLimitAnalyticsTable}
              analyticsFilter={analyticsFilter}
              setAnalyticsFilter={setAnalyticsFilter}
              applyFilterAnalytisData={applyFilterAnalytisData}
              discardFilterAnalytisData={discardFilterAnalytisData}
              selectedDateRange={props.selectedDateRange}
              workFlowData={props.workFlowData}
              triggerRefetch={() => setRefreshKey((prev) => prev + 1)}
            />
          </div>
          {/* <div className="sbscoTableContainer ucaTable">
            <UnAnswereAnalyticsTable
              title={"Unanswered Call Analysis"}
              columnsData={UnansweredCallTableColumns}
              tableData={unansweredUserData}
              unansweredTablePageNo={unansweredTablePageNo}
              setUnansweredsTablePageNo={setUnansweredsTablePageNo}
              pageLimitUnansweredTable={pageLimitUnansweredTable}
              setLimitUnansweredTable={setLimitUnansweredTable}
              unansweredFilter={unansweredFilter}
              setUnansweredFilter={setUnansweredFilter}
              applyFilteUnansweredData={applyFilteUnansweredData}
              discardFilterUnansweredData={discardFilterUnansweredData}
              selectedDateRange={props.selectedDateRange}
              scenarioId={props.workFlowData?.id}
            />
          </div> */}
        </SimpleGrid>

        {props.modalAllcallBreakdownData && (
          <Modal
            isOpen={props.modalAllcallBreakdownData}
            onClose={() => props.setModalCallBreakdownData(false)}
            size="xl"
            isCentered
          >
            <ModalOverlay />
            <ModalContent className="callInfoContents">
              <ModalHeader pb={2}>
                <Flex align="center" justify="space-between">
                  <Text fontSize="lg" fontWeight="bold" color="gray.800">
                    Call Information
                  </Text>
                  <Button
                    colorScheme="blue"
                    size="sm"
                    variant="solid"
                    leftIcon={<DownloadIcon />}
                    borderRadius="md"
                    boxShadow="sm"
                    bg="#2185d0"
                    color="white"
                    _hover={{ bg: "#1b70af" }}
                  >
                    Export
                  </Button>
                </Flex>
              </ModalHeader>

              <ModalBody
                className="callInfoCards"
                style={{ overflowY: "auto", maxHeight: "20em" }}
              >
                <Table variant="simple" size="sm">
                  <Thead bg="gray.100">
                    <Tr>
                      <Th textAlign="center">Call Type</Th>
                      <Th textAlign="center" isNumeric>
                        Count
                      </Th>
                      <Th textAlign="center"> Download Call Info</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {CALL_DURATIONS.map((row) => (
                      <Tr key={row.key}>
                        <Td>{row.label}</Td>

                        <Td isNumeric>{callInfoCounts[row.key] ?? 0}</Td>

                        <Td>
                          <Button
                            colorScheme="blue"
                            size="sm"
                            onClick={() => {
                              setCallDurationFilter(row.key);
                              props.setModalCallBreakdownData(false);
                            }}
                          >
                            Download Call Info
                          </Button>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>

                {/* Total Calls Summary */}
                <Box
                  mt={4}
                  pt={2}
                  maxW="200px"
                  borderWidth="1px"
                  borderRadius="md"
                  p={3}
                  boxShadow="sm"
                >
                  <Flex align="center" justify="space-between">
                    <Text fontSize="md" fontWeight="medium" color="gray.700">
                      Total Calls
                    </Text>
                    <Text fontWeight="bold" fontSize="md" color="gray.900">
                      {callBreakDownData?.totalCallAttempt || 0}
                    </Text>
                  </Flex>
                </Box>
              </ModalBody>

              <ModalFooter>
                <Button
                  variant="outline"
                  colorScheme="gray"
                  size="sm"
                  borderRadius="lg"
                  p={4}
                  boxShadow="sm"
                  _hover={{ bg: "gray.100" }}
                  onClick={() => props.setModalCallBreakdownData(false)}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        )}
      </Box>
    </>
  );
}
